import { formatRank } from "@memorang/helpers";
/* -----------------Child components--------------- */
import { Box, CustomAvatar } from "@memorang/ui";
import AvatarGenerator from "@memorang/ui/src/components/AvatarGenerator";
import type { TextStyle } from "react-native";
/* -----------------UI--------------- */
import { List, Text } from "react-native-paper";
import type { Style } from "react-native-paper/lib/typescript/components/List/utils";

type Props = {
	title: string;
	rank: number;
	xp: number;
	showDivider?: boolean;
	image: string;
	textStyle?: TextStyle;
	avatarType?: "initials" | "identicon";
};
const LeaderboardListItem = (props: Props) => {
	const { rank, title, xp, image, textStyle, avatarType } = props;

	const renderRight = (p: {
		color: string;
		style?: Style;
	}) => (
		<List.Icon
			{...p}
			icon={() => (
				<Text variant="labelLarge">{`${xp?.toLocaleString() ?? 0} XP`}</Text>
			)}
		/>
	);

	const renderLeft = (p: { color: string; style: Style }) => {
		const rankLabel = formatRank(rank);

		return (
			<Box flexDirection="row" alignItems="center" {...p}>
				{rankLabel ? (
					<Text style={{ minWidth: 16 }} variant="bodySmall">
						{rankLabel}
					</Text>
				) : null}
				<List.Icon
					{...p}
					icon={() =>
						image && !avatarType ? (
							<CustomAvatar size={40} avatar={image} />
						) : (
							<AvatarGenerator
								firstName={title}
								lastName={title}
								size={24}
								avatarType={avatarType}
								key={title}
								customStyle={{
									position: "relative",
									top: undefined,
								}}
							/>
						)
					}
					style={p.style}
				/>
			</Box>
		);
	};

	return (
		<>
			<List.Item
				title={title}
				titleStyle={{
					...(textStyle ?? {}),
				}}
				//@ts-expect-error - cursor is not a valid prop for List.Item
				style={{
					cursor: "default",
				}}
				right={renderRight}
				left={renderLeft}
			/>
		</>
	);
};

export default LeaderboardListItem;
